import * as React from "react";
import { SCREEN_WIDTH } from "../../../constants";
import * as _ from "lodash";
import VerticalAligner from "../VerticalAligner/VerticalAligner";

export interface BarItemProps {
  className?: string;
  label?: string;
  value?: number;
  year?:string;
  person?: string;
  width?: number;
  open?: boolean;
  handleClick?: any;
  keyIndex?: number;
  handleClose?: any;
  match?: any;
  selectedTab?: any;
  selectedData?: any;
  selectedCeoFilter?: any;
}

interface BarItemState {
  isContentVisible: boolean;
}

export class BarItem extends React.Component<BarItemProps, BarItemState> {
  constructor(e) {
    super(e);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => this.forceUpdate();

  render() {
    let { props, state } = this;

    let cls = props.className || "";
    let highestValue = this.props.selectedData.data[0].value;

    return (
      <div className={"bar-list__item " + cls}>
        <div className="bar-list__row">
          <div className="bar-list__block bar-list__block--label">
          
          {!this.props.selectedCeoFilter ?
            <span className="bar-label">{props.label}</span> : <span  className="bar-label--year">{props.year}</span>}


            <span className="bar-person">{props.person}</span>
          </div>
          <div
            className="bar-list__block bar-list__block--bar"
            style={
              this.props.selectedTab === "tech-giants"
                ? { backgroundColor: "#C6E8DB" }
                : { backgroundColor: "#FCF3C5" }
            }
          >
            <div
              className="bar-list__progress"
              style={
                this.props.selectedTab === "tech-giants"
                  ? { background: "#1CA371", width: props.width + "%" }
                  : { background: "#F0D630", width: props.width + "%" }
              }
            />
            <div
              style={
                props.value >= (highestValue - 4)
                  ? {
                      position: "absolute",
                      right: "5px",
                      lineHeight: "26px",
                    }
                  : { marginLeft: props.width + 0.5 + "%"}
              }
              className="bar-list__block bar-list__block--value"
            >
              <div>{`${props.value}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
